import { Button, Drawer, Space } from "antd";
import {
  AiOutlineClose,
  AiOutlineFacebook,
  AiOutlineLinkedin,
} from "react-icons/ai";
import Avatar from "../../../assets/user.png";
import { FiTwitter } from "react-icons/fi";
import { IoLogoInstagram } from "react-icons/io5";
import { RiMailSendLine } from "react-icons/ri";
import { useEffect, useState } from "react";
export default function ImpodatesPannel({
  isVisible,
  setVisible,
  selected,
}: any) {
  useEffect(() => {}, [selected]);
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Customer Important Dates</span>
        </div>
      }
      placement="right"
      width={600}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">Important Dates</div>
    </Drawer>
  );
}
